import { UPDATE_SECOND_ACTION_TYPE } from './modules/actionTypes';

export const updateSecondAction = (diff: number) => ({
  type: UPDATE_SECOND_ACTION_TYPE,
  payload: { second: diff },
});

export type SecondActionTypes = ReturnType<typeof updateSecondAction>;
